export default __webpack_public_path__ + "media/src/assets/fonts/Bitter-ExtraBold-3f31fb7a82173c51f7e3502678b4d695.ttf";